export default () => ({
    auth: null,
    dashStyle: null,
    push: null,
    devices: [],
    selectedDevice: {},
    notifications: [],
    newNotificationStatus: null,
    deviceActive: false,
    deviceInfo: null,
    deviceParams: null,
    deviceLastTime: null
  });